import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import apiCall from "./../../API/API";
import "bootstrap/dist/css/bootstrap.min.css";
import "./PayoutControls.css";
import { Container, Row, Col } from "react-bootstrap";
import { BiFilter } from "react-icons/bi";
import { GrPowerReset } from "react-icons/gr";

const formatAmount = (value) => parseFloat(value || 0).toFixed(2);

const PayoutControls = () => {
  const [incomeData, setIncomeData] = useState([]);
  const [totalToday, setTotalToday] = useState(0);
  const [totalIncome, setTotalIncome] = useState(0);
  const [activeTab, setActiveTab] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const [search, setsearch] = useState({
    username: "",
    search: "",
    startDate: "",
    endDate: "",
  });
  const [filterOpen, setFilterOpen] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab");
    if (tab) {
      setActiveTab(tab);
    }
  }, [location.search]);

  const toggleFilter = () => {
    setFilterOpen((prev) => !prev);
  };

  const hasActiveFilters =
    search.search || search.startDate || search.endDate;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setsearch((prev) => ({ ...prev, [name]: value }));
  };

  const buildQueryParams = (searchState) => {
    const queryParams = {
      ...Object.fromEntries(
        Object.entries(searchState).filter(
          ([_, value]) => value !== "" && value !== 0,
        ),
      ),
    };
    return queryParams;
  };

  const fetchData = async (searchState = search) => {
    try {
      const queryParams = new URLSearchParams(buildQueryParams(searchState));
      const queryString = queryParams.toString();
      const url = queryString
        ? `/payout-report?${queryString}`
        : "/payout-report";
      const response = await apiCall("GET", url);
      setIncomeData(response?.data);
      setTotalToday(response?.data?.totalTodaySum ?? 0);
      setTotalIncome(response?.data?.totalSum ?? 0);
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetFilter = () => {
    const cleared = {
      username: "",
      search: "",
      startDate: "",
      endDate: "",
    };
    setsearch(cleared);
    fetchData(cleared);
  };

  const AddFilter = () => {
    fetchData(search);
  };

  function handleTabClick(tab) {
    setActiveTab(tab);
    navigate(`/dashboard/${tab}`);
  }

  const incomeItems = Array.isArray(incomeData?.data) ? incomeData.data : [];

  return (
    <Container fluid className="admin-page payout-report-page">
      <div className="payout-head">
        <h1>Payout Report</h1>
        <p>Overview of platform income by type</p>
      </div>

      <section
        className={`payout-filter ${filterOpen ? "payout-filter--open" : ""}`}
        aria-label="Report filters"
      >
        <button
          type="button"
          className="payout-filter__header"
          onClick={toggleFilter}
          aria-expanded={filterOpen}
        >
          <span className="payout-filter__header-left">
            <span className="payout-filter__icon" aria-hidden>
              <BiFilter />
            </span>
            <span className="payout-filter__header-text">
              <span className="payout-filter__title">Filters</span>
              <span className="payout-filter__subtitle">
                Username or date range
              </span>
            </span>
          </span>
          <span className="payout-filter__header-right">
            {hasActiveFilters && (
              <span className="payout-filter__badge">Active</span>
            )}
            <span
              className={`payout-filter__chevron ${filterOpen ? "is-open" : ""}`}
              aria-hidden
            />
          </span>
        </button>

        <div className="payout-filter__body">
          <div className="payout-filter__inner">
          <Row className="g-3 payout-filter__fields">
            <Col xs={12} md={6} lg={4}>
              <label className="payout-filter__label" htmlFor="payout-search">
                Username
              </label>
              <input
                id="payout-search"
                type="text"
                name="search"
                className="payout-filter__input"
                placeholder="Search by username"
                value={search.search}
                onChange={handleChange}
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <label className="payout-filter__label" htmlFor="payout-start">
                Start date
              </label>
              <input
                id="payout-start"
                type="date"
                name="startDate"
                className="payout-filter__input"
                value={search.startDate}
                onChange={handleChange}
              />
            </Col>
            <Col xs={12} md={6} lg={4}>
              <label className="payout-filter__label" htmlFor="payout-end">
                End date
              </label>
              <input
                id="payout-end"
                type="date"
                name="endDate"
                className="payout-filter__input"
                value={search.endDate}
                onChange={handleChange}
              />
            </Col>
          </Row>
          <div className="payout-filter__actions">
            <button
              type="button"
              className="payout-filter__btn payout-filter__btn--primary"
              onClick={AddFilter}
            >
              <BiFilter aria-hidden />
              Apply filters
            </button>
            <button
              type="button"
              className="payout-filter__btn payout-filter__btn--secondary"
              onClick={resetFilter}
            >
              <GrPowerReset aria-hidden />
              Reset
            </button>
          </div>
          </div>
        </div>
      </section>

      <section className="payout-summary-featured" aria-label="Total income">
        <article className="payout-card payout-card--featured">
          <h3 className="payout-card__title">Total Income</h3>
          <div className="payout-card__metrics">
            <div className="payout-card__metric">
              <p className="payout-card__value">{formatAmount(totalIncome)}</p>
              <p className="payout-card__label">Total</p>
            </div>
            <div className="payout-card__metric">
              <p className="payout-card__value">{formatAmount(totalToday)}</p>
              <p className="payout-card__label">Today</p>
            </div>
          </div>
        </article>
      </section>

      <ul className="payout-income-grid">
        {incomeItems.length === 0 ? (
          <li className="payout-income-empty">No income data for this filter.</li>
        ) : (
          incomeItems.map((item) => (
            <li key={item?.slug || item?.name}>
              <button
                type="button"
                className={`payout-card w-100 text-start ${
                  activeTab === item?.slug ? "payout-card--active" : ""
                }`}
                onClick={() => handleTabClick(item?.slug)}
              >
                <h3 className="payout-card__title">{item?.name}</h3>
                <div className="payout-card__metrics">
                  <div className="payout-card__metric">
                    <p className="payout-card__value">
                      {formatAmount(item?.totalAmount)}
                    </p>
                    <p className="payout-card__label">Total</p>
                  </div>
                  <div className="payout-card__metric">
                    <p className="payout-card__value">
                      {formatAmount(item?.todayAmount)}
                    </p>
                    <p className="payout-card__label">Today</p>
                  </div>
                </div>
              </button>
            </li>
          ))
        )}
      </ul>
    </Container>
  );
};

export default PayoutControls;
